import { useEffect, useRef } from "react";
import { BACKEND_URL } from "@/lib/api";

export const useWebSocket = (onEvent) => {
  const wsRef = useRef(null);
  const callbackRef = useRef(onEvent);
  callbackRef.current = onEvent;

  useEffect(() => {
    const wsUrl = BACKEND_URL.replace(/^http/, "ws") + "/api/ws";
    let alive = true;
    let reconnectTimer = null;

    const connect = () => {
      try {
        const ws = new WebSocket(wsUrl);
        wsRef.current = ws;
        ws.onmessage = (e) => {
          try {
            const data = JSON.parse(e.data);
            callbackRef.current?.(data);
          } catch {}
        };
        ws.onclose = () => {
          if (alive) reconnectTimer = setTimeout(connect, 2500);
        };
        ws.onerror = () => { try { ws.close(); } catch {} };
      } catch {
        if (alive) reconnectTimer = setTimeout(connect, 2500);
      }
    };
    connect();
    return () => {
      alive = false;
      if (reconnectTimer) clearTimeout(reconnectTimer);
      try { wsRef.current?.close(); } catch {}
    };
  }, []);
};
